import { Trans } from '../../atoms'

const OrdineIndirizzo = ({
  ordine,
  indirizzo,
  label,
  conSpedizione,
  conPorto,
  conVettore,
  conTrans,
  style,
}) => {
  const rowClass = style == 'data-row' ? 'pdf__data-row' : 'ordine-indirizzo__row'
  return (
    <div className="ordine-indirizzo">
      {label && (
        <h3 className="ordine-indirizzo__title">
          <Trans chiave={label} />
        </h3>
      )}
      <div className={style == 'data-row' ? 'pdf__data-table' : ''}>
        {indirizzo && (
          <>
            <p className={rowClass}>
              {conTrans && (
                <span>
                  <Trans chiave="Ragione sociale:" />{' '}
                </span>
              )}
              {indirizzo.ragione_sociale ? (
                <span>{indirizzo.ragione_sociale}</span>
              ) : (
                <span>
                  {indirizzo.nome} {indirizzo.cognome}
                </span>
              )}
              <span>{indirizzo.ragione_sociale}</span>
            </p>
            <p className={rowClass}>
              {conTrans && (
                <span>
                  <Trans chiave="Indirizzo:" />{' '}
                </span>
              )}
              <span>{indirizzo.indirizzo}</span>
            </p>
            <p className={rowClass}>
              {conTrans && (
                <span>
                  <Trans chiave="Località:" />{' '}
                </span>
              )}
              <span>{indirizzo.citta}</span>
            </p>
            <p className={rowClass}>
              {conTrans && (
                <span>
                  <Trans chiave="Provincia:" />{' '}
                </span>
              )}
              <span>{indirizzo.provincia}</span>
            </p>
            <p className={rowClass}>
              {conTrans && (
                <span>
                  <Trans chiave="Cap:" />{' '}
                </span>
              )}
              <span>{indirizzo.cap}</span>
            </p>
          </>
        )}
        {conSpedizione && (
          <p className={rowClass}>
            {conTrans && (
              <span>
                <Trans chiave="Modalità di spedizione:" />{' '}
              </span>
            )}
            <span>{ordine.modalita_spedizione}</span>
          </p>
        )}
        {conPorto && (
          <p className={rowClass}>
            {conTrans && (
              <span>
                <Trans chiave="Porto:" />{' '}
              </span>
            )}
            <span>{ordine.porto}</span>
          </p>
        )}
        {conVettore && (
          <p className={rowClass}>
            {conTrans && (
              <span>
                <Trans chiave="Vettore:" />{' '}
              </span>
            )}
            <span>{ordine.vettore}</span>
          </p>
        )}
      </div>
    </div>
  )
}

export default OrdineIndirizzo
